export const STABLE_EMPTY_ARRAY_REF: never[] = Object.freeze([]) as never[];
